<select [(ngModel)]="selectedLocale" name="language">
	@for (option of localeOptions; track option.langCode) {
		<option [value]="option.langCode">{{ option.title }}</option>
	}
</select>

<button>
	<img src="assets/dropdown-arrow.svg" alt="Dropdown Arrow"/>
</button>
